export default "__VITE_ASSET__DhatcZHt__"